module.exports = __webpack_public_path__ + "static/media/AfghanistanBanner.3709b7e3.svg";